import React, { useState, useEffect } from "react";

import InputSelect from "../../../components/InputSelect";
import Input from "../../../components/Input";
import api from "../../../services/api";
import { createColorsOptions } from "../../../helpers/selects";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";
import InputCheckboxUnique from "../../../components/InputCheckboxUnique";
import { ModalDelete } from "../../../components/ModalDelete";
import { toast } from "react-toastify";
import { renderError } from "../../../helpers/errors";

export const SubproductsTab = ({ product, subproducts, setSubproducts }) => {
    const [hasVariation, setHasVariation] = useState(false);

    const [gettingColors, setGettingColor] = useState(true);
    const [colors, setColors] = useState([]);
    const [subproductToChooseImage, setSubproductToChooseImage] = useState(null);
    const [subproductToChoosePrices, setSubproductToChoosePrices] = useState(null);

    const [confirmIndex, setConfirmIndex] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const makeBlankSubproduct = () => ({
        id: null,
        supplier_product_id: product.id,
        supplier_product_image_id: null,
        supplier_color_id: null,
        sku: `${product.sku}`,
        status: true,
        image: null,
        stock: 0,
        prices: [],
        _tmpId: crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`
    });

    useEffect(() => {
        getColors();
        verifyHasVariation();
    }, []);

    useEffect(() => {
        setSubproducts(subproducts);
    }, [subproducts]);

    useEffect(() => {
        handleHasSubproductsChange();
    }, [hasVariation]);

    const getColors = () => {
        setGettingColor(true);
        api.get(`/color`).then(res => {
            setColors(res.data?.resources ?? []);
            setGettingColor(false);
        }).catch(() => setGettingColor(false));
    };

    const handleStockChange = (value, index) => {
        const to = [...subproducts];
        console.log(to);
        
        const num = Number(String(value).replace(/\D/g, "")) || 0;
        to[index].stock = num;
        setSubproducts(to);
    };

    const verifyHasVariation = () => {
        if (product.subproducts.length > 0 && (product.subproducts[0].supplier_color_id !== null || product.subproducts[0].image != null)) {
            setHasVariation(true);
        }
    };

    const handleHasSubproductsChange = () => {
        if (hasVariation) {
            if (product.subproducts.length > 0 && (product.subproducts[0].supplier_color_id !== null || product.subproducts[0].image != null)) {
                setSubproducts(product.subproducts);
            } else {
                setSubproducts([]);
            }
        } else {
            const first = Array.isArray(product?.subproducts) && product.subproducts.length > 0
                ? product.subproducts[0]
                : null;

            setSubproducts([{
                id: first?.id ?? null,
                supplier_product_id: product.id,
                supplier_product_image_id: null,
                supplier_color_id: null,
                sku: `${product.sku}`,
                status: true,
                image: null,
                stock: Number(first?.stock ?? 0),
                prices: first?.prices ?? [],
                _tmpId: crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`
            }]);
        }
    };

    const handleColorChange = (value, index) => {
        const color = colors.find(c => c.id === value);

        setSubproducts(prev =>
            prev.map((sp, i) => {
                if (i !== index) return sp;

                return {
                    ...sp,
                    supplier_color_id: value,
                    sku: color ? `${product.sku}-${color.sku}` : product.sku
                };
            })
        );
    };

    const handleImageChange = image => {
        setSubproducts(prev => {
            const to = [...prev];
            const sp = to[subproductToChooseImage];
            if (!sp) return prev;
            if (sp.supplier_product_image_id !== image.id) {
                sp.supplier_product_image_id = image.id;
                sp.image = image;
            } else {
                sp.supplier_product_image_id = null;
                sp.image = null;
            }
            return to;
        });
    };

    const addVariation = () => {
        setSubproducts(prev => [...prev, makeBlankSubproduct()]);
    };

    const handleVariationDelete = (index) => {
        setConfirmIndex(index);
        setConfirmDelete(true);
    };

    const deleteVariation = () => {
        if (confirmIndex === null) return;
        const sp = subproducts[confirmIndex];
        
        if (!sp?.id) {
            setSubproducts(prev => prev.filter((_, i) => i !== confirmIndex));
            setConfirmDelete(false);
            setConfirmIndex(null);
            return;
        }

        api.delete(`/subproduct/${sp.id}`)
            .then(res => {
                setSubproducts(prev => prev.filter((_, i) => i !== confirmIndex));
                toast.success('Variação deletada com sucesso');
            }).catch(error => {
                renderError(error);
            }).finally(() => {
                setConfirmDelete(false);
                setConfirmIndex(null);
            });
    };

    const addPrice = () => {
        setSubproducts(prevSubproducts => {
            const updatedSubproducts = [...prevSubproducts];
            updatedSubproducts[subproductToChoosePrices] = {
                ...updatedSubproducts[subproductToChoosePrices],
                prices: [
                    ...updatedSubproducts[subproductToChoosePrices].prices,
                    {
                        init_quantity: '',
                        final_quantity: '',
                        formatted_price: 'R$ 0,00'
                    }
                ]
            };
            return updatedSubproducts;
        });
    };

    const handleChangeParam = (priceIndex, param, value) => {
        setSubproducts(prevSubproducts => {
            const updatedSubproducts = [...prevSubproducts];
            updatedSubproducts[subproductToChoosePrices] = {
                ...updatedSubproducts[subproductToChoosePrices],
                prices: updatedSubproducts[subproductToChoosePrices].prices.map((price, index) => {
                    if (index === priceIndex) {
                        return {
                            ...price,
                            [param]: value
                        };
                    }
                    return price;
                })
            };
            return updatedSubproducts;
        });
    };

    const deletePrice = priceIndex => {
        setSubproducts(prevSubproducts => {
            const updatedSubproducts = [...prevSubproducts];
            updatedSubproducts[subproductToChoosePrices] = {
                ...updatedSubproducts[subproductToChoosePrices],
                prices: updatedSubproducts[subproductToChoosePrices].prices.filter((_, index) => index !== priceIndex)
            };
            return updatedSubproducts;
        });
    };

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteVariation}
                loading={gettingColors}
                close={() => setConfirmDelete(false)}
            />

            {subproductToChooseImage !== null && (
                <Modal
                    title="Escolher imagem"
                    show={true}
                    close={() => setSubproductToChooseImage(null)}
                >
                    <div className="section subproduct-images">
                        {product.images.map(image => (
                            <button
                                key={image.id}
                                onClick={() => handleImageChange(image)}
                                className={
                                    subproducts[subproductToChooseImage]?.supplier_product_image_id === image.id
                                        ? "active"
                                        : ""
                                }
                                type="button"
                            >
                                <img src={image.image_url.thumbnail} />
                            </button>
                        ))}
                    </div>
                </Modal>
            )}

            {subproductToChoosePrices !== null && (
                <Modal
                    title="Tabela de preços"
                    show={true}
                    close={() => setSubproductToChoosePrices(null)}
                >
                    <div>
                        {subproducts[subproductToChoosePrices].prices.map((price, index) => (
                            <div className="section" key={index}>
                                <div className="row">
                                    <div className="col">
                                        <Input label="Quant. inicial *" mask="convertToInt" value={price.init_quantity} change={value => handleChangeParam(index, 'init_quantity', value)} error={!price.init_quantity || price.init_quantity === 0 ? 'Campo obrigatório' : ''} />
                                    </div>
                                    <div className="col">
                                        <Input label="Quant. final *" mask="convertToInt" value={price.final_quantity} change={value => handleChangeParam(index, 'final_quantity', value)} error={!price.final_quantity || price.final_quantity === 0 ? 'Campo obrigatório' : ''} />
                                    </div>
                                    <div className="col">
                                        <Input label="Preço *" value={price.formatted_price} mask="convertToMoney" change={value => handleChangeParam(index, 'formatted_price', value)} error={!price.formatted_price || price.formatted_price === 'R$ 0,00' ? 'Campo obrigatório' : ''} />
                                    </div>                                    
                                    <div className="col-1 col-customization-delete">
                                        <Button type="delete" svg="delete-small" action={() => deletePrice(index)} />
                                    </div>                                    
                                </div>
                            </div>
                        ))}

                        {
                            <Button
                                type="link"
                                size="small"
                                text="Cadastrar mais variações de preço"
                                full={true}
                                action={addPrice}
                            />
                        }
                    </div>
                </Modal>
            )}

            {gettingColors && <p>Carregando...</p>}

            <div>
                <InputCheckboxUnique
                    label="Esse produto possui variação de cor"
                    checked={hasVariation}
                    change={() => setHasVariation(!hasVariation)}
                />

                {subproducts.length > 0 && hasVariation &&
                    <h2 className="section-title">Detalhes das variações</h2>
                }

                {subproducts.map((subproduct, index) => (
                    <div key={subproduct._tmpId ?? index} className="row">
                        {hasVariation && <>
                            <div className="col-1">
                                <button
                                    className="btn-change-image"
                                    onClick={() => setSubproductToChooseImage(index)}
                                    type="button"
                                >
                                    {subproduct?.image ? (
                                        <img src={subproduct.image?.image_url?.thumbnail} />
                                    ) : (
                                        <Icon name="image" size={24} />
                                    )}
                                    <span>Escolher</span>
                                </button>
                            </div>

                            <div className="col-2">
                                <InputSelect
                                    label="Cor da variação"
                                    options={createColorsOptions(colors, "name", "id")}
                                    value={subproduct.supplier_color_id}
                                    change={val => handleColorChange(val, index)}
                                />
                            </div>

                            <div className="col-2">
                                <Input label="SKU" value={subproduct.sku} disabled />
                            </div>

                            <div className="col-2">
                                <Input
                                    label="Estoque"
                                    value={subproduct.stock.toLocaleString("pt-BR")}
                                    mask="convertToInt"
                                    change={value => handleStockChange(value, index)}
                                    right={<span className="small">unidade{subproduct.stock !== 1 ? "s" : ""}</span>}
                                />
                            </div>
                            <div className="col-2">
                                <Input
                                    label="Preço a partir de"
                                    value={subproduct.prices.length > 0 
                                        ? subproduct.prices[subproduct.prices.length - 1].formatted_price 
                                        : 'R$ 0,00'}
                                    disabled={true}
                                    right={<Button svg="table" type="icon" action={() => setSubproductToChoosePrices(index)} />}
                                />
                            </div>

                            <div className="col-2">
                                <Button
                                    type="secondary"
                                    size="regular mt-1"
                                    svg="delete-small"
                                    text="Excluir"
                                    action={() => handleVariationDelete(index)}
                                    loading={gettingColors}
                                />
                            </div>
                        </>}

                        {!hasVariation && <>
                            <div className="col-2">
                                <Input
                                    label="Estoque"
                                    value={subproduct.stock.toLocaleString('pt-BR')}
                                    mask="convertToInt"
                                    change={value => handleStockChange(value, index)}
                                    right={<span className="small">unidade{subproduct.stock !== 1 ? 's' : ''}</span>}
                                />
                            </div>

                            <div className="col-2">
                                <Input
                                    label="Preço a partir de"
                                    value={subproduct.prices.length > 0 
                                        ? subproduct.prices[subproduct.prices.length - 1].formatted_price 
                                        : 'R$ 0,00'}
                                    disabled={true}
                                    right={<Button svg={`table`} type={`icon`} action={() => setSubproductToChoosePrices(index)}></Button>}
                                />
                            </div>
                        </>}
                    </div>
                ))}
            </div>

            {hasVariation && <div className="row">
                <div className="col-2">
                    <Button
                        type="primary"
                        size="small"
                        svg="plus-white"
                        text="Adicionar variação"
                        action={addVariation}
                    />
                </div>
            </div>}
        </>
    );
};

export default SubproductsTab;
